import { useQuery } from '@tanstack/react-query';

import { getRatePlanBookingImpact } from '~/services/RatePlanBookingImpact';

export function useRatePlanBookingImpact(vendorId: string, ratePlanId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['ratePlanBookingImpact', vendorId, ratePlanId],
    queryFn: () => {
      if (!ratePlanId) throw new Error('Rate plan is required');
      return getRatePlanBookingImpact(vendorId, ratePlanId);
    },
    enabled: enabled && !!vendorId && !!ratePlanId,
    retry: false,
    staleTime: 60_000,
  });
}
